import resume from './KoshikeSaikumar.pdf'
import image2 from "../../src/Image.jpg"

export const headerData = {
    name: 'Koshike Saikumar',
    title: "Web Developer",
    desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    image: image2,
    resumePdf: resume
}
